// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// function WhatsAppFloat(){

//     const WhatsApp = () => {
//     const phone = "+919199245536"; 
//     const message = "Hello Little Duckling! I want know more about your Services."; 
//     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

//     window.open(url, "_blank");
//   };

//     return(
//         <div className="container">
// <button onClick={WhatsApp} className="btn btn-rounded"
//  style={{top:'90%',zIndex:'1200',transformOrigin:'right-center',position:'fixed',
//  right:'0%',backgroundColor:'transparent'}}>
//     <FontAwesomeIcon icon={faWhatsapp} size="2x" style={{fontSize:'30px', color: "green" }}/></button>
//         </div>
//     )
// }
// export default WhatsAppFloat








import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import './whatsapp.css'
function WhatsAppFloat(){
  const WhatsApp = () => {
    const phone = "919633963361";
    const message = "Hi Little Duckling, I would like to know more about your Services";
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };



    return(
        <div>

 
   <button className='whats' onClick={WhatsApp}>
    <FontAwesomeIcon className='what' icon={faWhatsapp} style={{marginRight:'0px',fontSize:'50px', color: "green" }}/>
    </button>
        </div>
    )
}
export default WhatsAppFloat